export class HashUtils {
  static async hash(value: string): Promise<string> {
    return await this.sha256Hex(value);
  }

  /**
   * Web Crypto APIを使用してSHA-256形式でハッシュ化を行う
   * （crypto-jsはtiming attack脆弱性があると指摘されているため使用しない）
   *
   * @param value ハッシュ化対象文字列
   * @returns ハッシュ化された文字列
   */
  private static async sha256Hex(value: string): Promise<string> {
    // Encode the input as a Uint8Array
    const encoder = new TextEncoder();
    const data = encoder.encode(value);

    // Hash the data
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);

    // Convert the ArrayBuffer to hex string
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hexString = hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');

    return hexString;
  }
}
